<template  >
    <div class="scholar">
        <div class="scholar__head">研究学者</div>
        <ul class="scholar__list">
            <li class="list-item">
                <div class="label">姓名</div>
                <div >相关发布量</div>
                <div class="num">100</div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.scholar{
    &__head{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
        border-left: 4px solid #396de7;
        padding-left: 10px;
    }
    &__list{
        .list-item{
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            color: #333;
            margin-bottom: 10px;
            .label{ 
                color:#396de7
            } 
            .num{ 
                color:#396de7
            }
        }
    }
} 
</style>